(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function ($) {
  let carousel = $('.carousel')
  let interval = carousel.attr('data-interval')


  if (interval > 0) {
    let carousel = $('.carousel')
    let interval = carousel.attr('data-interval')

    if (interval > 0) {
      let width = 0
      let paused = false
      let stopped = false

      let startInterval = setInterval(function handleInterval() {
        if (!paused)
          width++

        $(carousel.find('.carousel-progress-bar')).css('width', width * (1000 / interval) + '%')
      }, 10);

      carousel.on('slide.bs.carousel', function () {
        if (!stopped) {
          width = 0
          paused = false
        }
      })

      carousel.hover(
        function() {
          paused = true
        },
        function() {
          if (!stopped) {
            paused = false
            width = 0
          }
        }
      )

      $(carousel.find('.carousel-autoplay-btn')).click(function () {
        if ($(this).hasClass('is-playing')) {
          $(this)
            .removeClass('is-playing')
            .addClass('is-paused')
            .attr('aria-label', $(this).attr('data-label-play'))
          carousel.find('.carousel-inner').attr('aria-live', 'polite')
          paused = true
          stopped = true
          carousel.carousel('pause')
        } else {
          $(this)
            .removeClass('is-paused')
            .addClass('is-playing')
            .attr('aria-label', $(this).attr('data-label-stop'))
          carousel.find('.carousel-inner').attr('aria-live', 'off')
          paused = false
          stopped = false
          width = 0
          carousel.carousel('cycle')
        }
      })

    }

  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    
jQuery(document).ready(function ($) {

  // Sticky summary
  let header = $('#shopify-section-header')
  let top = 20

  if($(header).css('position') == 'sticky') {
    top += header.outerHeight()
  }

  $('.sticky-cart-summary').css({
    'position': 'sticky',
    'top': top,
    'z-index': 1019
  })

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
jQuery(document).ready(function ($) {

  // Autofocus search input
  $('#navbar-search').on('shown.bs.dropdown', function(e) {
    $('#navbar-search input[type=search]').focus()
  })

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  // Newsletter ajax form
  // jQuery(document).ready(function ($) {
  //  $('form#newsletter-form').submit(function(e) {
  //   e.preventDefault()
  //    jQuery.post('/contact', $(this).serialize(), function(data) {
  //      console.log(data)
  //    })
  //   })
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read base URL from data attribute
      var baseUrl = productRecommendationsSection.dataset.baseUrl;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Test that its working
      // console.log(`Product id: ${productId}, baseUrl: ${baseUrl}, limit: ${limit}`)
      // Build request URL
      var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        }

        // Fix native lazy loading
        if ('loading' in HTMLImageElement.prototype) {
          const images = document.querySelectorAll('img[loading="lazy"]')
          images.forEach(img => {
            img.src = img.dataset.src
          })
        }
      };
      request.send();
    };

  // Listen for changes done in the Theme Editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations") {
        loadProductRecommendationsIntoSection();
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();
  
  } catch(e) { console.error(e); }
})();
})();
